import React, { Component } from 'react';
import TablaFiltrosRow from './TablaFiltrosRow';

class TablaFiltros extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { movimientosFiltradosPorDescripcion, idChecksAjusteCargoArray, destildarTildarCheckFiltroAjusteCargo } = this.props;

        return (
            <table className={"modal-filtro-tabla-width noBorder modal-filtros-tabla modalLogIntentosScroll"}>
                <tbody>
                    {movimientosFiltradosPorDescripcion && movimientosFiltradosPorDescripcion.length > 0
                        ?
                        movimientosFiltradosPorDescripcion.map((ajusteCargo, index) => {
                            return <TablaFiltrosRow destildarTildarCheckFiltroAjusteCargo={destildarTildarCheckFiltroAjusteCargo} ajusteCargo={ajusteCargo} index={index} idChecksAjusteCargoArray={idChecksAjusteCargoArray} />
                        })
                        :
                        null
                    }
                </tbody>
            </table>
        );
    }
}

export default TablaFiltros;